import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getContainerClasses = ({ dsf_size }) => {
  const containerClasses = ["flex-auto", "bg-neutral-100"];
  if (dsf_size === "small") {
    containerClasses.push("h-4", "rounded-xxs");
  } else if (dsf_size === "medium") {
    containerClasses.push("h-8", "rounded-xs");
  } else if (dsf_size === "large") {
    containerClasses.push("h-16", "rounded-sm");
  }
  return concatClasses(containerClasses);
};
const getWrapperClasses = ({ dsf_size, progress }) => {
  const progressClasses = ["h-full", "bg-secondary-300", "w-100"];
  if (dsf_size === "small") {
    progressClasses.push("rounded-l-xxs");
    if (progress === 100) {
      progressClasses.push("rounded-r-xxs");
    }
  } else if (dsf_size === "medium") {
    progressClasses.push("rounded-l-xs");
    if (progress === 100) {
      progressClasses.push("rounded-r-xs");
    }
  } else if (dsf_size === "large") {
    progressClasses.push("rounded-l-sm");
    if (progress === 100) {
      progressClasses.push("rounded-r-sm");
    }
  }
  return concatClasses(progressClasses);
};
export {
  getContainerClasses,
  getWrapperClasses
};
